import React from 'react';

/**
 * OptimizedImage - Serves WebP images with JPG/PNG fallback
 * Automatically converts image paths to WebP format
 */
const OptimizedImage = ({ src, alt, className, style, ...props }) => {
  // Convert the source to WebP version
  const webpSrc = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  // Get the original format for fallback
  const originalSrc = src;

  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={originalSrc}
        alt={alt}
        className={className}
        style={style}
        loading="lazy"
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;
